import c from "./consts";

export default {
    [c.COMPANIES](state, value) {
        state[c.COMPANIES] = value;
    },

    [c.IS_LOADING](state, value) {
        state[c.IS_LOADING] = value;
    },

    [c.SELECTED_COMPANY](state, value) {
        state[c.SELECTED_COMPANY] = value;
    },
};